module.exports = __webpack_public_path__ + "img/report-3.d37dfc20.png";